var map = {
	"./aerzte.png": 807,
	"./amazon.png": 2320,
	"./autoscout24.png": 1517,
	"./check24.png": 9476,
	"./ekomi.png": 5915,
	"./fewo.png": 3073,
	"./glassdoor.png": 1337,
	"./golocal.png": 3465,
	"./google.png": 565,
	"./gutebanken.png": 8942,
	"./immoscout24.svg.png": 5196,
	"./indeed.png": 127,
	"./jameda.png": 8244,
	"./jobvoting.png": 6198,
	"./klinikbewertungen.png": 3720,
	"./kununu.png": 116,
	"./mobile.png": 4754,
	"./omr.png": 8644,
	"./sanego.png": 2173,
	"./shopauskunft.png": 2055,
	"./tellows.png": 7820,
	"./trivago.png": 5828,
	"./trustedshops.png": 3068,
	"./yelp.png": 9346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1827;